import React from 'react';

import Text from '../Text';

interface InputLabelProps {
  children: React.ReactNode;
  required?: boolean;
}

const REQUIRED_ASTERISK_COLOR = '#ef4444';

export function InputLabel({children, required}: InputLabelProps) {
  return (
    <Text style={{marginBottom: 5}}>
      {children}
      {!!required && (
        <Text
          style={{
            fontSize: 14,
            color: REQUIRED_ASTERISK_COLOR,
            marginLeft: 2,
            lineHeight: 14,
          }}
          accessibilityLabel="required field">
          {' *'}
        </Text>
      )}
    </Text>
  );
}
